export enum AccountTypeEnum {
  CORRENTE = "CORRENTE",
  POUPANCA = "POUPANCA",
}

export enum PaymentMethodEnum {
  CREDIT_CARD = "CREDIT_CARD",
  DEBIT_CARD = "DEBIT_CARD",
  PIX = "PIX",
  BOLETO = "BOLETO",
  UNKNOWN = "UNKNOWN",
}

export enum TransactionTabEnum {
  GENERAL = "general",
  ENTRIES = "entries",
  TRANSFERS = "transfers",
}

export enum TransactionTypeEnum {
  ENTRY = "ENTRY",
  TRANSFER = "TRANSFER",
}

export enum UITransactionTypeEnum {
  ALL = "ALL",
  ENTRY = "ENTRY",
  TRANSFER = "TRANSFER",
}

export interface BankAccountResponseDto {
  holderName: string;
  holderDocument: string;
  accountBank: string;
  accountAgency: string;
  accountNumber: string;
  accountType: AccountTypeEnum;
  updatedAt: string;
}

export interface BankItemDto {
  code: string;
  name: string;
}

export interface BanksResponseDto {
  items: BankItemDto[];
  updatedAt: string;
}

export interface SummaryPeriodDto {
  from?: string;
  to?: string;
}

export interface SummaryResponseDto {
  currency: string;
  transferredTotal: string;
  receivableTotal: string;
  period: SummaryPeriodDto;
  generatedAt: string;
  bankAccount?: BankAccountResponseDto;
}

export interface SettlementInfoDto {
  expectedTransferAt?: string;
  transferredAt?: string;
  destinationBankCode?: string;
  transferUid?: string;
}

export interface PaymentMethodDetailDto {
  method: string;
  label: string;
  lastDigits?: string;
  installments?: number;
  brand?: string;
  holderName?: string;
}

export interface TransactionDetailResponseDto extends TransactionItemDto {
  orderId?: string;
  settlement?: SettlementInfoDto;
  paymentMethodDetail: PaymentMethodDetailDto;
}

export interface PaymentMethodDto {
  method: PaymentMethodEnum;
  label: string;
  lastDigits?: string;
  installments?: number;
}

export interface TransactionItemDto {
  id: string;
  type: TransactionTypeEnum;
  label: string;
  occurredAt: string;
  amount: string;
  currency: string;
  transactionId?: number;
  paymentMethod?: PaymentMethodDto;
  orderId?: string;
}

export interface TransactionsFiltersDto {
  tab: TransactionTabEnum;
  from?: string;
  to?: string;
}

export interface TransactionsPaginationDto {
  page: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
}

export interface TransactionsTotalsDto {
  label: string;
  amount: string;
  currency: string;
  entriesAmount: string;
  transfersAmount: string;
}

/**
 * DTO de resposta para o endpoint GET /financial/transactions.
 *
 * Retorna lista paginada de transações (entradas e/ou transferências),
 * com informações sobre filtros aplicados, paginação e totais agregados.
 */
export interface TransactionsResponseDto {
  filters: TransactionsFiltersDto;
  items: TransactionItemDto[];
  pagination: TransactionsPaginationDto;
  totals: TransactionsTotalsDto;
}
